export const appReducer = (
  state = {
    baseUrlApi: "https://colagio.shratech.com/",
  },
  action
) => {
  switch (action.type) {
    case "SET_BASE_API": {
      return { ...state, baseUrlApi: action.baseUrlApi };
    }
    default: {
      return state;
    }
  }
};
